import { useState } from 'react'
import { apiPost, apiDelete } from '../../api'
import type { DateRow } from '../../api'

const enGBLong = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'long' })

interface Props {
  rows: DateRow[]
  onChange: () => void
}

export default function DatesStrip({ rows, onChange }: Props) {
  const [adding, setAdding] = useState(false)
  const [label, setLabel] = useState('')
  const [dateIso, setDateIso] = useState('')
  const [annual, setAnnual] = useState(true)

  const create = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!label.trim() || !dateIso) return
    await apiPost('/home/dates', { label: label.trim(), date_iso: dateIso, is_annual: annual })
    setAdding(false); setLabel(''); setDateIso(''); setAnnual(true)
    onChange()
  }

  const remove = async (id: number) => {
    if (!confirm('Remove this date?')) return
    await apiDelete(`/home/dates/${id}`)
    onChange()
  }

  return (
    <div>
      <div className="dates-strip">
        {rows.map((r, i) => (
          <div key={r.id} className={`date-card ${i === 0 && r.days_until <= 7 ? 'soon' : ''}`} onClick={() => remove(r.id)} role="button" title="Tap to remove">
            <div className="label">
              {i === 0 && '❤ '}{r.label}
            </div>
            <div className="days">{r.days_until === 0 ? 'today' : r.days_until === 1 ? 'tomorrow' : `${r.days_until} days`}</div>
            <div className="iso">{enGBLong.format(new Date(`${r.date_iso}T00:00:00`))}</div>
          </div>
        ))}
        {!adding && (
          <button type="button" className="date-card" onClick={() => setAdding(true)} style={{ minWidth: 80 }}>
            +
          </button>
        )}
      </div>
      {adding && (
        <form onSubmit={create} style={{ marginTop: '0.5rem', display: 'grid', gap: '0.5rem' }}>
          <input type="text" placeholder="Label (e.g. Anniversary)" value={label} onChange={e => setLabel(e.target.value)} />
          <input type="date" value={dateIso} onChange={e => setDateIso(e.target.value)} />
          <label className="secondary"><input type="checkbox" checked={annual} onChange={e => setAnnual(e.target.checked)} /> Recurs each year</label>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <button type="submit">Add</button>
            <button type="button" onClick={() => setAdding(false)}>Cancel</button>
          </div>
        </form>
      )}
    </div>
  )
}
